import React from 'react'
import { render } from 'react-snapshot'
import smoothscroll from 'smoothscroll-polyfill'
import App from './App'
import './index.css'

smoothscroll.polyfill()

render(<App />, document.getElementById('root'))
